import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useWindowDimensions from "../../Services/useWindowDimensions";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { Box } from "@mui/material";
import styles from "./Css/style.module.css";
import Card from "./Card";
import { experiencesMainData } from "../../Services/dymmyData";
import { theme } from "../../Assets/Theme/theme";

const PreviousBtn = (props) => {
  const { className, onClick } = props;
  return (
    <>
      <Box onClick={onClick} className={styles.preBtn}>
        <ArrowBackOutlinedIcon
          className={className}
          onClick={onClick}
          sx={{
            color: "#fff",
            background: theme.colors.orange,
            fontSize: "10px",
            padding: "8px",
            width: "35px",
            height: "35px",
            position: "absolute",
            borderRadius: "50%",
            zIndex: 99,
            "&:hover": {
              background: theme.colors.orange,
              color: "#fff",
            },
          }}
        />
      </Box>
    </>
  );
};
const NextBtn = (props) => {
  const { className, onClick } = props;
  return (
    <>
      <Box onClick={onClick} className={styles.nextBtn}>
        <ArrowForwardOutlinedIcon
          className={className}
          onClick={onClick}
          sx={{
            color: "#fff",
            background: theme.colors.orange,
            fontSize: "10px",
            padding: "8px",
            width: "35px",
            height: "35px",
            position: "absolute",
            borderRadius: "50%",
            "&:hover": {
              background: theme.colors.orange,
              color: "#fff",
            },
          }}
        />
      </Box>
    </>
  );
};

const CardsSlider = ({ data, name }) => {
  let { width } = useWindowDimensions();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    prevArrow: <PreviousBtn />,
    nextArrow: <NextBtn />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          centerMode: false,
        },
      },
      {
        breakpoint: 1224,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          centerMode: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
          centerMode: false,
          dots: false,
        },
      },
    ],
  };

  return (
    <Box>
      {data?.length > 3 ||
      width < 558 ||
      (data?.length === 2 && width < 1024) ? (
        <Slider {...settings} className={styles.slider}>
          {data?.map((value, index) => {
            return (
              <Box
                key={index}
                sx={{
                  padding: { md: "0 20px", xs: 0 },
                }}
              >
                <Card data={value} />
              </Box>
            );
          })}
        </Slider>
      ) : (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: 5,
          }}
        >
          {data?.map((value, index) => (
            <Card key={index} data={value} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CardsSlider;
